/*
 * コンサルタント ファイル共有の更新
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE = 'API_UPDATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE';
/** コンサルタント ファイル共有：メッセージの送信 */
export const apiUpdateProRfpShareDocumentMessage = ({ json, path: { id } }, meta) => apiUpdate(API_UPDATE_PRO_RFP_SHARE_DOCUMENT_MESSAGE, `/professional/rfp/${id}/share_document_message`, json, Object.assign(Object.assign({}, meta), { id }));
